import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";

import axios from "axios";
import { BASE_API_URL } from "../const";
import Register from "./Register";

const Auth = ({ onAuthSuccess }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [openRegister, setOpenRegister] = useState(false);

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${BASE_API_URL}/api/user/login`, {
        login: login,
        password: password,
      });
      if (response.data.success) {
        const { token } = response.data.data;
        localStorage.setItem("mbase.login", login);
        localStorage.setItem("mbase.password", password);
        localStorage.setItem("mbase.token", token);

        onAuthSuccess(); // переход на AppWrapper
      }
    } catch (error) {
      setLogin("");
      setPassword("");
      alert("Неправильный логин или пароль");
      console.error("Ошибка авторизации", error);
    }
  };

  const handleOpenRegister = () => setOpenRegister(true);
  const handleCloseRegister = () => setOpenRegister(false);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ backgroundColor: "#F5F8FA" }}
    >
      {/* Логотип */}
      {/* <img src="/path/to/logo.png" alt="Logo" style={{ marginBottom: 16 }} /> */}

      {/* Заголовок */}
      <Typography variant="h5" color="primary" sx={{ marginBottom: 2 }}>
        Редактор каналов
      </Typography>

      {/* Поля ввода */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2}
        width="300px"
      >
        <TextField
          label="Логин"
          variant="outlined"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AccountCircle />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Пароль"
          variant="outlined"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleLogin}
          fullWidth
        >
          Войти
        </Button>
        <Button variant="contained" onClick={handleOpenRegister}>
          Регистрация
        </Button>
      </Box>

      {/* Диалог регистрации */}
      <Dialog open={openRegister} onClose={handleCloseRegister}>
        <Register
          onClose={handleCloseRegister}
          onRegisterSuccess={onAuthSuccess}
        />
      </Dialog>
    </Box>
  );
};

export default Auth;
